<template>
  <div class="tab-box flex flex-around flex-column bg-2">
    <div class="produce-content">
      <img :src="winPoster" class="full-img">
      <span class="produce-hit">长按图片保存分享至朋友圈</span>
    </div>
    <div class="btn-box flex flex-around">
      <button class="btn btn-3" @click="goLottery">{{ drawInfo.draw_status === 102 ? '查看奖品' : '马上抽奖'}}</button>
      <button class="btn btn-3" @click="goLink">去看房</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Produce',
  data () {
    return {
    }
  },
  computed: {
    winPoster () {
      return this.$store.state.winPoster
    },
    drawInfo () {
      return this.$store.state.drawInfo
    }
  },
  inject: ['slideHandle', 'infoHandle', 'shareHandle'],
  methods: {
    goLink () {
      window.location.href = 'https://redco.yesvsoft.com/m/company/switchcity'
    },
    goLottery () {
      let drawstatus = this.drawInfo.draw_status
      if (drawstatus === 1) {
        this.slideHandle(3)
      } else if (drawstatus === 101) {
        this.$alert.warn(this.drawInfo.draw_msg)
      } else if (drawstatus === 102) {
        this.$store.setState('prize_title', this.drawInfo.draw_msg)
        this.infoHandle(true)
      } else if (drawstatus === 103) {
        this.shareHandle(true)
      }
    },
    isDrawFn () {
      this.$alert.load()
      this.$http.isDraw().then(res => {
        this.$alert.close()
        if (res.status === 1) {
          this.$store.setState('drawInfo', res.result.drawInfo)
        } else {
          this.$alert.warn(res.msg)
        }
      })
    }
  },
  created () {
    this.$store.state.pageName = 'Produce'
    this.isDrawFn()
  },
  mounted () {

  },
  beforeDestroy () {

  }
}
</script>

<style scoped>
.tab-box {
  padding: 2vh 0;
}
.produce-content {
  position: relative;
  width: 5.65rem;
  height: 9.07rem;
  box-sizing: border-box;
  border: .06rem solid #fff;
}
.produce-hit {
  position: absolute;
  top: 102%;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: .24rem;
  color: #333;
  font-weight: bold;
}
.btn-box {
  position: relative;
  width: 85%;
}
</style>
